import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { Button, Card, Divider, Modal, Table, Tabs, Tag, message } from 'antd'
import {
  getPartner,
  getPushTemplateList,
  createPushTemplate,
  updatePushTemplate,
  deletePushTemplate,
  getHelperList,
  createHelper,
  updateHelper,
  deleteHelper
} from '../../modules/apiPartner'
import { useDeepEffect } from '../../utils/hooks'
import PushTemplateForm from './components/PushTemplateForm'
import HelperForm from './components/HelperForm'


const ApiPartnerDetail = (props) => {
  const partnerId = props.match.params.id
  const dispatch = useDispatch()
  const [templateForm, setTemplateForm] = useState({
    visible: false,
    data: {}
  })
  const [helperForm, setHelperForm] = useState({ visible: false, data: {} })

  const { partner, pushTemplateList, helperList, isLoading } = useSelector(
    (state) => ({
      partner: state.apiPartner.partner,
      pushTemplateList: state.apiPartner.pushTemplateList,
      helperList: state.apiPartner.helperList,
      isLoading: state.apiPartner.isLoading
    }),
    []
  )

  useDeepEffect(() => {
    dispatch(getPartner(partnerId))
    dispatch(getPushTemplateList(partnerId))
    dispatch(getHelperList(partnerId))
  }, [partnerId])

  // ---------- push template ----------

  const closeTemplateForm = () => setTemplateForm({ visible: false, data: {} })

  const onSaveTemplate = async (data) => {
    const id = templateForm.data.id
    const ok = id
      ? await dispatch(updatePushTemplate(id, data))
      : await dispatch(createPushTemplate(data))
    if (ok) {
      message.success('บันทึกสำเร็จ')
      closeTemplateForm()
      await dispatch(getPushTemplateList(partnerId))
    }
  }

  const onDeleteTemplate = (record) => {
    Modal.confirm({
      title: `ลบ Push Template "${record.apiName}" ?`,
      content: 'ถ้ามีร้านเชื่อมต่อ template นี้อยู่ ระบบจะไม่ให้ลบ',
      okText: 'ลบ',
      okType: 'danger',
      cancelText: 'ยกเลิก',
      onOk: async () => {
        const ok = await dispatch(deletePushTemplate(record.id))
        if (ok) {
          message.success('ลบสำเร็จ')
          await dispatch(getPushTemplateList(partnerId))
        }
      }
    })
  }

  // ---------- helper ----------

  const closeHelperForm = () => setHelperForm({ visible: false, data: {} })

  const onSaveHelper = async (data) => {
    const id = helperForm.data.id
    const ok = id
      ? await dispatch(updateHelper(id, data))
      : await dispatch(createHelper(data))
    if (ok) {
      message.success('บันทึกสำเร็จ')
      closeHelperForm()
      await dispatch(getHelperList(partnerId))
    }
  }

  const onDeleteHelper = (record) => {
    Modal.confirm({
      title: `ลบ Helper "${record.apiName}" ?`,
      okText: 'ลบ',
      okType: 'danger',
      cancelText: 'ยกเลิก',
      onOk: async () => {
        const ok = await dispatch(deleteHelper(record.id))
        if (ok) {
          message.success('ลบสำเร็จ')
          await dispatch(getHelperList(partnerId))
        }
      }
    })
  }

  const actionColumn = (onEdit, onDelete) => ({
    title: '',
    key: 'action',
    width: 100,
    align: 'center',
    render: (_text, record) => (
      <span>
        <Button
          type="primary"
          size="small"
          shape="circle"
          icon="edit"
          onClick={() => onEdit(record)}
        />
        <Divider type="vertical" />
        <Button
          type="danger"
          size="small"
          shape="circle"
          icon="delete"
          onClick={() => onDelete(record)}
        />
      </span>
    )
  })

  const templateColumns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 70, align: 'center' },
    { title: 'API Name', dataIndex: 'apiName', key: 'apiName', width: 180 },
    { title: 'คำอธิบาย', dataIndex: 'apiDescription', key: 'apiDescription' },
    {
      title: 'Integration Type',
      dataIndex: 'integrationType',
      key: 'integrationType',
      width: 180,
      render: (value) => <span style={{ whiteSpace: 'nowrap' }}>{value}</span>
    },
    { title: 'Endpoint', dataIndex: 'endpointApi', key: 'endpointApi' },
    actionColumn(
      (record) => setTemplateForm({ visible: true, data: record }),
      onDeleteTemplate
    )
  ]

  const helperColumns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 70, align: 'center' },
    { title: 'API Name', dataIndex: 'apiName', key: 'apiName', width: 180 },
    { title: 'Endpoint', dataIndex: 'endpointApi', key: 'endpointApi' },
    {
      title: 'Static Params',
      dataIndex: 'staticParams',
      key: 'staticParams',
      render: (value) => <code>{value || '-'}</code>
    },
    actionColumn(
      (record) => setHelperForm({ visible: true, data: record }),
      onDeleteHelper
    )
  ]

  return (
    <Card
      title={
        <span>
          <Link to="/api-partner">
            <Button
              icon="arrow-left"
              size="small"
              style={{ marginRight: 12 }}
            />
          </Link>
          <Link to="/api-partner">API Partner</Link> /{' '}
          {partner.name || partnerId}{' '}
          {partner.id && !partner.isActive && <Tag>Inactive</Tag>}
        </span>
      }>
      <Tabs defaultActiveKey="pushTemplate">
        <Tabs.TabPane tab="Push Template" key="pushTemplate">
          <div style={{ textAlign: 'right', marginBottom: 12 }}>
            <Button
              type="primary"
              onClick={() => setTemplateForm({ visible: true, data: {} })}>
              สร้าง Push Template
            </Button>
          </div>
          <Table
            rowKey="id"
            loading={isLoading}
            columns={templateColumns}
            dataSource={pushTemplateList}
            pagination={false}
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Helper" key="helper">
          <div style={{ textAlign: 'right', marginBottom: 12 }}>
            <Button
              type="primary"
              onClick={() => setHelperForm({ visible: true, data: {} })}>
              สร้าง Helper
            </Button>
          </div>
          <Table
            rowKey="id"
            loading={isLoading}
            columns={helperColumns}
            dataSource={helperList}
            pagination={false}
          />
        </Tabs.TabPane>
      </Tabs>
      <PushTemplateForm
        visible={templateForm.visible}
        formData={templateForm.data}
        partnerId={partnerId}
        onOk={onSaveTemplate}
        onCancel={closeTemplateForm}
      />
      <HelperForm
        visible={helperForm.visible}
        formData={helperForm.data}
        partnerId={partnerId}
        onOk={onSaveHelper}
        onCancel={closeHelperForm}
      />
    </Card>
  )
}

export default ApiPartnerDetail
